import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerAffiliationModalComponent } from './historical-customer-affiliation-modal.component';
import { HistoricalCustomerAffiliationComponent } from './historical-customer-affiliation.component';

@NgModule({
    declarations: [
        HistoricalCustomerAffiliationComponent,
        HistoricalCustomerAffiliationModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerAffiliationComponent,
        HistoricalCustomerAffiliationModalComponent
    ]
})

export class HistoricalCustomerAffiliationModule { }
